import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseNotifications, ApiResponseNotification } from '@/api/responses/notifications'

export namespace NotificationsApi {
  /**
   * お知らせ一覧取得
   *
   * @param count 取得件数
   * @param options オプション(任意)
   * @param options.type お知らせ種別
   * @param options.pageNumber ページ番号
   * @returns お知らせ情報
   */
  export async function getNotifications(
    count: number,
    options?: {
      /** お知らせ種別 */
      type?: string
      /** ページ番号 */
      pageNumber?: number
    }
  ): Promise<ApiResponseNotifications> {
    const params = {
      count: count,
    }

    if (options) {
      if (options.type) {
        Object.assign(params, { type: options.type })
      }
      if (options.pageNumber) {
        Object.assign(params, { pageNumber: options.pageNumber })
      }
    }

    return await ApiBase.get('/notifications', params)
  }

  /**
   * お知らせ詳細取得
   *
   * @param id お知らせID
   * @returns お知らせ情報
   */
  export async function notification(id: number): Promise<ApiResponseNotification> {
    return await ApiBase.get(`/notifications/${id}`)
  }
}
